<div id="acc-root" class="acc-overlay" (click)="onClose()">
  <section class="acc-card" role="dialog" aria-modal="true" aria-labelledby="acc-title" (click)="$event.stopPropagation()">
    
    <!-- Vue liste des situations -->
    <div *ngIf="viewMode() === 'list'" class="acc-view">
      <div class="acc-header">
        <h2 id="acc-title">{{ 'previsions.contextModal.list.title' | translate }}</h2>
        <div style="display: flex; gap: 12px; align-items: center;">
          <button type="button" class="acc-btn-add-context" (click)="createContext()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            {{ 'previsions.contextModal.common.add' | translate }}
          </button>
          <button type="button" class="acc-close" (click)="onClose()" [attr.aria-label]="'previsions.contextModal.common.close' | translate">×</button>
        </div>
      </div>

      <div class="acc-table-wrapper">
        <table class="acc-table">
          <thead>
            <tr>
              <th>{{ 'previsions.contextModal.list.table.situation' | translate }}</th>
              <th>{{ 'previsions.contextModal.common.description' | translate }}</th>
              <th>{{ 'previsions.contextModal.list.table.periodsCount' | translate }}</th>
              <th>{{ 'previsions.contextModal.common.view' | translate }}</th>
              <th>{{ 'previsions.contextModal.common.edit' | translate }}</th>
              <th>{{ 'previsions.contextModal.common.delete' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let context of fullContexts()">
              <td>{{ context.name }}</td>
              <td>{{ context.description || '-' }}</td>
              <td>{{ context.periods?.length || 0 }}</td>
              <td>
                <button type="button" class="acc-btn-icon" (click)="viewContext(context)" [title]="'previsions.contextModal.common.view' | translate">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </button>
              </td>
              <td>
                <button type="button" class="acc-btn-icon" (click)="editContext(context)" [title]="'previsions.contextModal.common.edit' | translate" *ngIf="context.name !== 'Par défaut' && context.name !== 'Normale'">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                  </svg>
                </button>
              </td>
              <td>
                <button type="button" class="acc-btn-icon acc-btn-delete" [title]="'previsions.contextModal.common.delete' | translate" *ngIf="context.name !== 'Par défaut' && context.name !== 'Normale'" (click)="confirmDeleteContext(context)">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Vue modification de la situation -->
    <div *ngIf="viewMode() === 'edit'" class="acc-view">
      <div class="acc-header">
        <div class="acc-header-with-back">
          <button type="button" class="acc-back-btn" (click)="backToList()" [title]="'previsions.contextModal.common.back' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
          </button>
          <h2 id="acc-title">{{ 'previsions.contextModal.editTitle' | translate }}</h2>
        </div>
        <button type="button" class="acc-close" (click)="onClose()" [attr.aria-label]="'previsions.contextModal.common.close' | translate">×</button>
      </div>

      <div class="acc-content">
        <form [formGroup]="contextForm" (ngSubmit)="saveContext()" class="context-form">
          <div class="form-group">
            <label for="name-edit">{{ 'previsions.contextModal.form.nameLabel' | translate }}</label>
            <input
              id="name-edit"
              type="text"
              formControlName="name"
              class="form-input"
              [class.error]="contextForm.get('name')?.invalid && contextForm.get('name')?.touched"
            />
            <span class="error-msg" *ngIf="contextForm.get('name')?.invalid && contextForm.get('name')?.touched">
              {{ 'previsions.contextModal.form.nameRequired' | translate }}
            </span>
          </div>

          <div class="form-group">
            <label for="description-edit">{{ 'previsions.contextModal.common.description' | translate }}</label>
            <textarea
              id="description-edit"
              formControlName="description"
              class="form-textarea"
              rows="3"
              [placeholder]="'previsions.contextModal.form.descriptionPlaceholder' | translate"
            ></textarea>
          </div>

          <div class="periods-section">
            <div class="section-header">
              <h3 class="section-title">{{ 'previsions.contextModal.form.periodsTitle' | translate }}</h3>
              <button type="button" class="acc-btn-add" (click)="addPeriod()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 5v14M5 12h14"/>
                </svg>
                {{ 'previsions.contextModal.form.addPeriod' | translate }}
              </button>
            </div>

            <div formArrayName="periods" class="periods-list">
              <div *ngFor="let period of periodsArray.controls; let i = index" [formGroupName]="i" class="period-item">
                <div class="period-fields">
                  <div class="form-group full-width">
                    <label>{{ 'previsions.contextModal.form.periodNameLabel' | translate }}</label>
                    <input
                      type="text"
                      formControlName="name"
                      class="form-input"
                      [placeholder]="'previsions.contextModal.form.periodNamePlaceholder' | translate"
                      [class.error]="period.get('name')?.invalid && period.get('name')?.touched"
                    />
                  </div>
                  <div class="period-row">
                    <div class="form-group">
                      <label>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                          <line x1="16" y1="2" x2="16" y2="6"/>
                          <line x1="8" y1="2" x2="8" y2="6"/>
                          <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                        {{ 'previsions.contextModal.form.startDateLabel' | translate }}
                      </label>
                      <input
                        type="date"
                        formControlName="startDate"
                        class="form-input"
                        [class.error]="period.get('startDate')?.invalid && period.get('startDate')?.touched"
                      />
                    </div>
                    <div class="form-group">
                      <label>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                          <line x1="16" y1="2" x2="16" y2="6"/>
                          <line x1="8" y1="2" x2="8" y2="6"/>
                          <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                        {{ 'previsions.contextModal.form.endDateLabel' | translate }}
                      </label>
                      <input
                        type="date"
                        formControlName="endDate"
                        class="form-input"
                        [class.error]="period.get('endDate')?.invalid && period.get('endDate')?.touched"
                      />
                    </div>
                  </div>
                  <div class="form-group full-width">
                    <label>{{ 'previsions.contextModal.form.commentLabel' | translate }}</label>
                    <textarea
                      formControlName="comment"
                      class="form-textarea"
                      rows="2"
                      [placeholder]="'previsions.contextModal.form.commentPlaceholder' | translate"
                    ></textarea>
                  </div>
                </div>
                <button type="button" class="acc-btn-remove" (click)="removePeriod(i)" [title]="'previsions.contextModal.common.delete' | translate">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                </button>
              </div>
            </div>

            <div *ngIf="periodsArray.length === 0" class="empty-periods">
              {{ 'previsions.contextModal.form.noPeriods' | translate }}
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="acc-btn acc-cancel" (click)="backToList()">{{ 'previsions.contextModal.common.cancel' | translate }}</button>
            <button type="submit" class="acc-btn acc-primary">
              {{ 'previsions.contextModal.common.save' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Vue visualisation de la situation -->
    <div *ngIf="viewMode() === 'view'" class="acc-view">
      <div class="acc-header">
        <div class="acc-header-with-back">
          <button type="button" class="acc-back-btn" (click)="backToList()" [title]="'previsions.contextModal.common.back' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
          </button>
          <h2 id="acc-title">{{ 'previsions.contextModal.view.title' | translate }}</h2>
        </div>
        <button type="button" class="acc-close" (click)="onClose()" [attr.aria-label]="'previsions.contextModal.common.close' | translate">×</button>
      </div>

      <div class="acc-content">
        <div class="context-view">
          <div class="view-section">
            <h3 class="view-label">{{ 'previsions.contextModal.view.nameLabel' | translate }}</h3>
            <p class="view-value">{{ selectedContext()?.name }}</p>
          </div>

          <div class="view-section">
            <h3 class="view-label">{{ 'previsions.contextModal.common.description' | translate }}</h3>
            <p class="view-value">{{ selectedContext()?.description || ('previsions.contextModal.view.noDescription' | translate) }}</p>
          </div>

          <div class="view-section">
            <h3 class="view-label">{{ 'previsions.contextModal.form.periodsTitle' | translate }}</h3>
            <div class="view-periods">
              <div class="view-period-item" *ngFor="let period of selectedContext()?.periods">
                <div class="view-period-header">
                  <div>
                    <div class="view-period-name">{{ period.name }}</div>
                    <div class="view-period-dates">
                      {{ 'previsions.contextModal.view.from' | translate }} {{ period.startDate | date:'dd/MM/yyyy' }}
                      <ng-container *ngIf="period.endDate === '9999-12-31'; else endDateBlock">{{ 'previsions.contextModal.view.untilToday' | translate }}</ng-container>
                      <ng-template #endDateBlock>{{ 'previsions.contextModal.view.to' | translate }} {{ period.endDate | date:'dd/MM/yyyy' }}</ng-template>
                    </div>
                  </div>
                  <div class="view-period-stats">
                    <span class="stat-item" *ngIf="getPeriodStats(period.id)">{{ 'previsions.contextModal.view.totalLabel' | translate }} <strong>{{ getPeriodStats(period.id).totalScans }} {{ 'previsions.contextModal.view.scansUnit' | translate }}</strong></span>
                  </div>
                </div>
                <div class="view-period-subtitle" *ngIf="getPeriodStats(period.id)?.avgScansPerDay">{{ 'previsions.contextModal.view.avgPerDayTitle' | translate }}</div>
                <div class="view-period-details" *ngIf="getPeriodStats(period.id)?.avgScansPerDay">
                  <div class="detail-row">
                    <span class="detail-day">{{ 'previsions.contextModal.view.days.monday' | translate }}</span>
                    <span class="detail-scans">{{ $safeNavigationMigration(getPeriodStats(period.id)?.avgScansPerDay?.monday?.avg) | number:'1.0-0' }} {{ 'previsions.contextModal.view.scansUnit' | translate }} ({{ getPeriodStats(period.id)?.avgScansPerDay?.monday?.count }} {{ 'previsions.contextModal.view.daysUnit' | translate }})</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-day">{{ 'previsions.contextModal.view.days.tuesday' | translate }}</span>
                    <span class="detail-scans">{{ $safeNavigationMigration(getPeriodStats(period.id)?.avgScansPerDay?.tuesday?.avg) | number:'1.0-0' }} {{ 'previsions.contextModal.view.scansUnit' | translate }} ({{ getPeriodStats(period.id)?.avgScansPerDay?.tuesday?.count }} {{ 'previsions.contextModal.view.daysUnit' | translate }})</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-day">{{ 'previsions.contextModal.view.days.wednesday' | translate }}</span>
                    <span class="detail-scans">{{ $safeNavigationMigration(getPeriodStats(period.id)?.avgScansPerDay?.wednesday?.avg) | number:'1.0-0' }} {{ 'previsions.contextModal.view.scansUnit' | translate }} ({{ getPeriodStats(period.id)?.avgScansPerDay?.wednesday?.count }} {{ 'previsions.contextModal.view.daysUnit' | translate }})</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-day">{{ 'previsions.contextModal.view.days.thursday' | translate }}</span>
                    <span class="detail-scans">{{ $safeNavigationMigration(getPeriodStats(period.id)?.avgScansPerDay?.thursday?.avg) | number:'1.0-0' }} {{ 'previsions.contextModal.view.scansUnit' | translate }} ({{ getPeriodStats(period.id)?.avgScansPerDay?.thursday?.count }} {{ 'previsions.contextModal.view.daysUnit' | translate }})</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-day">{{ 'previsions.contextModal.view.days.friday' | translate }}</span>
                    <span class="detail-scans">{{ $safeNavigationMigration(getPeriodStats(period.id)?.avgScansPerDay?.friday?.avg) | number:'1.0-0' }} {{ 'previsions.contextModal.view.scansUnit' | translate }} ({{ getPeriodStats(period.id)?.avgScansPerDay?.friday?.count }} {{ 'previsions.contextModal.view.daysUnit' | translate }})</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-day">{{ 'previsions.contextModal.view.days.saturday' | translate }}</span>
                    <span class="detail-scans">{{ $safeNavigationMigration(getPeriodStats(period.id)?.avgScansPerDay?.saturday?.avg) | number:'1.0-0' }} {{ 'previsions.contextModal.view.scansUnit' | translate }} ({{ getPeriodStats(period.id)?.avgScansPerDay?.saturday?.count }} {{ 'previsions.contextModal.view.daysUnit' | translate }})</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-day">{{ 'previsions.contextModal.view.days.sunday' | translate }}</span>
                    <span class="detail-scans">{{ $safeNavigationMigration(getPeriodStats(period.id)?.avgScansPerDay?.sunday?.avg) | number:'1.0-0' }} {{ 'previsions.contextModal.view.scansUnit' | translate }} ({{ getPeriodStats(period.id)?.avgScansPerDay?.sunday?.count }} {{ 'previsions.contextModal.view.daysUnit' | translate }})</span>
                  </div>
                </div>
                <div class="view-period-comment" *ngIf="period.comment">
                  <strong>{{ 'previsions.contextModal.view.commentLabel' | translate }}</strong> {{ period.comment }}
                </div>
              </div>
              <div *ngIf="!selectedContext()?.periods || selectedContext()?.periods?.length === 0" class="empty-periods">
                {{ 'previsions.contextModal.view.noPeriods' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Vue création d'une nouvelle situation -->
    <div *ngIf="viewMode() === 'create'" class="acc-view">
      <div class="acc-header">
        <div class="acc-header-with-back">
          <button type="button" class="acc-back-btn" (click)="backToList()" [title]="'previsions.contextModal.common.back' | translate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
          </button>
          <h2 id="acc-title">{{ 'previsions.contextModal.createTitle' | translate }}</h2>
        </div>
        <button type="button" class="acc-close" (click)="onClose()" [attr.aria-label]="'previsions.contextModal.common.close' | translate">×</button>
      </div>

      <div class="acc-content">
        <form [formGroup]="contextForm" (ngSubmit)="saveContext()" class="context-form">
          <div class="form-group">
            <label for="name-create">{{ 'previsions.contextModal.form.nameLabel' | translate }}</label>
            <input
              id="name-create"
              type="text"
              formControlName="name"
              class="form-input"
              [class.error]="contextForm.get('name')?.invalid && contextForm.get('name')?.touched"
            />
            <span class="error-msg" *ngIf="contextForm.get('name')?.invalid && contextForm.get('name')?.touched">
              {{ 'previsions.contextModal.form.nameRequired' | translate }}
            </span>
          </div>

          <div class="form-group">
            <label for="description-create">{{ 'previsions.contextModal.common.description' | translate }}</label>
            <textarea
              id="description-create"
              formControlName="description"
              class="form-textarea"
              rows="3"
              [placeholder]="'previsions.contextModal.form.descriptionPlaceholder' | translate"
            ></textarea>
          </div>

          <div class="periods-section">
            <div class="section-header">
              <h3 class="section-title">{{ 'previsions.contextModal.form.periodsTitle' | translate }}</h3>
              <button type="button" class="acc-btn-add" (click)="addPeriod()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 5v14M5 12h14"/>
                </svg>
                {{ 'previsions.contextModal.form.addPeriod' | translate }}
              </button>
            </div>

            <div formArrayName="periods" class="periods-list">
              <div *ngFor="let period of periodsArray.controls; let i = index" [formGroupName]="i" class="period-item">
                <div class="period-fields">
                  <div class="form-group full-width">
                    <label>{{ 'previsions.contextModal.form.periodNameLabel' | translate }}</label>
                    <input
                      type="text"
                      formControlName="name"
                      class="form-input"
                      [placeholder]="'previsions.contextModal.form.periodNamePlaceholder' | translate"
                      [class.error]="period.get('name')?.invalid && period.get('name')?.touched"
                    />
                  </div>
                  <div class="period-row">
                    <div class="form-group">
                      <label>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                          <line x1="16" y1="2" x2="16" y2="6"/>
                          <line x1="8" y1="2" x2="8" y2="6"/>
                          <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                        {{ 'previsions.contextModal.form.startDateLabel' | translate }}
                      </label>
                      <input
                        type="date"
                        formControlName="startDate"
                        class="form-input"
                        [class.error]="period.get('startDate')?.invalid && period.get('startDate')?.touched"
                      />
                    </div>
                    <div class="form-group">
                      <label>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                          <line x1="16" y1="2" x2="16" y2="6"/>
                          <line x1="8" y1="2" x2="8" y2="6"/>
                          <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                        {{ 'previsions.contextModal.form.endDateLabel' | translate }}
                      </label>
                      <input
                        type="date"
                        formControlName="endDate"
                        class="form-input"
                        [class.error]="period.get('endDate')?.invalid && period.get('endDate')?.touched"
                      />
                    </div>
                  </div>
                  <div class="form-group full-width">
                    <label>{{ 'previsions.contextModal.form.commentLabel' | translate }}</label>
                    <textarea
                      formControlName="comment"
                      class="form-textarea"
                      rows="2"
                      [placeholder]="'previsions.contextModal.form.commentPlaceholder' | translate"
                    ></textarea>
                  </div>
                </div>
                <button type="button" class="acc-btn-remove" (click)="removePeriod(i)" [title]="'previsions.contextModal.common.delete' | translate">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                </button>
              </div>
            </div>

            <div *ngIf="periodsArray.length === 0" class="empty-periods">
              {{ 'previsions.contextModal.form.noPeriods' | translate }}
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="acc-btn acc-cancel" (click)="backToList()">{{ 'previsions.contextModal.common.cancel' | translate }}</button>
            <button type="submit" class="acc-btn acc-primary">
              {{ 'previsions.contextModal.common.create' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>

  </section>
</div>

<!-- Popup de confirmation suppression -->
<div *ngIf="showDeleteConfirm()" class="delete-modal-overlay" (click)="cancelDelete()">
  <div class="delete-modal-content" (click)="$event.stopPropagation()">
    <h3>{{ 'previsions.contextModal.deleteContextModal.title' | translate }}</h3>
    <p>{{ 'previsions.contextModal.deleteContextModal.message' | translate:{ name: $safeNavigationMigration(contextToDelete()?.name) } }}</p>
    <div class="delete-modal-actions">
      <button type="button" class="btn-cancel" (click)="cancelDelete()">{{ 'previsions.contextModal.common.cancel' | translate }}</button>
      <button type="button" class="btn-delete" (click)="deleteContext()" [disabled]="loading()">
        {{ (loading() ? 'previsions.contextModal.deleteContextModal.deleting' : 'previsions.contextModal.common.delete') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Popup de confirmation suppression période -->
<div *ngIf="showDeletePeriodConfirm()" class="delete-modal-overlay" (click)="cancelRemovePeriod()">
  <div class="delete-modal-content" (click)="$event.stopPropagation()">
    <h3>{{ 'previsions.contextModal.deletePeriodModal.title' | translate }}</h3>
    <p>{{ 'previsions.contextModal.deletePeriodModal.message' | translate }}</p>
    <div class="delete-modal-actions">
      <button type="button" class="btn-cancel" (click)="cancelRemovePeriod()">{{ 'previsions.contextModal.common.cancel' | translate }}</button>
      <button type="button" class="btn-delete" (click)="confirmRemovePeriod()">
        {{ 'previsions.contextModal.common.delete' | translate }}
      </button>
    </div>
  </div>
</div>
